// extracted by mini-css-extract-plugin
export default {"suspenseErrorDialog":"suspenseErrorDialog____Dmb7","suspenseErrorDialogTitle":"suspenseErrorDialogTitle___cTUX9"};